import { render, staticRenderFns } from "./BidInfo.vue?vue&type=template&id=94fcd2d4&"
import script from "./BidInfo.vue?vue&type=script&lang=ts&"
export * from "./BidInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BidInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports